import { ICMSCompatibleComponent } from "@/types/ICMSCompatibleComponent";
import { IAsset } from "@/types/IAsset";

export enum EFormType {
  Text = 'text',
  Multiline = 'multiline',
  Email = 'email',
  Password = 'password',
  Checkbox = 'checkbox',
}

export interface IFormItemProps extends Partial<ICMSCompatibleComponent> {
  label: string;
  type: EFormType;
  formName: string;
  errorMessage: string;
  regexValidation: string;
  required?: boolean;
  backgroundColor?: string;
}

export interface IFormProps extends Partial<ICMSCompatibleComponent> {
  submitEndpoint: string,
  recaptchaKey: string,
  formItems: IFormItemProps[],
  backgroundColor: string,

  action?: 'download-file',
  asset?: IAsset;
}
